export function formatMWH(value?: number | null) {
	if (value === undefined || value === null) {
		return "-";
	}
	return "" + value.toFixed(0);
}
